// @todo: Migrate to 'Button' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {WBButton} from '@wandb/weave/common/components/elements/WBButtonNew';
import * as globals from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Input, Modal as SemanticModal, Popup} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import searchIcon from '../../assets/ic-search.svg';

export const Modal = styled(SemanticModal)`
  padding: 32px;
  max-width: 500px;
`;

export const Header = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${globals.MOON_950};
`;

export const Subheader = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${globals.MOON_600};
  margin-top: 12px;
`;

export const LoadedContent = styled.div`
  position: relative;
  min-height: 100px;
  margin-top: 24px;
`;

export const FilterInput = styled(Input).attrs({iconPosition: `left`})`
  width: 100%;

  &&&&& input {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

export const SearchIcon = styled.img.attrs({src: searchIcon})`
  position: absolute;
  left: 14px;
  top: 0;
  bottom: 0;
  margin: auto;
`;

export const Options = styled.div`
  margin-top: 16px;
  max-height: 360px;
  overflow: auto;
`;

export const Name = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${globals.TEXT_PRIMARY_COLOR};
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Details = styled.div`
  font-size: 12px;
  color: ${globals.MOON_600};
  margin-top: 4px;
`;

export const SrcIcon = styled.img`
  position: absolute;
  right: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
`;

export const Option = styled.div<{selected: boolean; disabled: boolean}>`
  position: relative;
  padding: 12px 50px 12px 10px;
  border: 1px solid;
  border-radius: 4px;
  &:not(:first-child) {
    margin-top: 10px;
  }

  ${p =>
    !p.disabled &&
    css`
      cursor: pointer;
    `}

  border-color: ${globals.MOON_150};
  ${SrcIcon} {
    color: ${globals.MOON_200};
  }

  ${p =>
    !p.disabled &&
    !p.selected &&
    css`
      &:hover {
        border-color: ${globals.TEAL_450};
      }
    `}

  ${p =>
    p.selected &&
    css`
      border-color: ${globals.TEAL_550};
      ${SrcIcon} {
        color: ${globals.TEAL_600};
      }
    `}

  ${p =>
    p.disabled &&
    css`
      ${Name} {
        color: ${globals.MOON_500};
      }
      ${Details} {
        color: ${globals.MOON_400};
      }
    `}
`;

export const DisabledPopup = styled(Popup)`
  &&&&& {
    display: flex;
    align-items: center;
    border-radius: 4px;
    background: rgba(75, 78, 82, 95%);
    padding: 14px 16px;
    font-size: 14px;
    color: ${globals.white};
    max-width: none;
    margin: 0;
  }
`;

export const DisabledPopupContent = styled.div`
  display: flex;
  align-items: center;
`;

export const DisabledPopupIcon = styled(Icon).attrs({name: `info`})`
  font-size: 16px;
  color: ${globals.SIENNA_300};
  margin-right: 7px;
`;

export const CloseButton = styled(WBButton).attrs({variant: `confirm`})`
  &&&&& {
    margin-top: 16px;
  }
`;
